import React from "react";

import { Section } from "../ui/atoms/section";
import { useTranslation } from "react-i18next";
import { ListPhones } from "../ui/molecules/list-phones";
import { createUuid } from "../utils/uuid";
import sizes from "../ui/sizes.scss";
import { FusionLayout } from "@/parts/fusion-layout";
import { observer } from "mobx-react";

export const PagePhones = observer((): JSX.Element => {
    const { t } = useTranslation();
    return (
        <FusionLayout breadcrumb={t("page.phones.title")} classic>
            <Section fill>
                <ListPhones listStateId={createUuid()} maxHeight={`${sizes.listMaxHeight}`} />
            </Section>
        </FusionLayout>
    );
});
